import React from 'react';
import { Alert } from 'reactstrap';
import { t } from '../utils/negotiationCopy';

const TEXT = {
  id: 'Negosiasi selesai. Semua cargo sudah Price Accepted atau Closed. Pemenang dipilih di Awarding.',
  en: 'Negotiation finished. Every cargo is Price Accepted or Closed.',
};

const NegotiationDoneBanner = ({ mode = 'buyer' }) => (
  <Alert color='success' className='mb-0'>
    <i className='ri-checkbox-circle-line me-2 align-middle'></i>
    {t(TEXT, mode)}
  </Alert>
);

export default NegotiationDoneBanner;
